import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { IAppState } from '../state/app.state';
import { Store } from '@ngrx/store';
import {GetRace, ERaceActions, GetRaceSuccess, GetRaceVideoXBNET} from '../actions/race.actions';
import { switchMap, map, startWith, mapTo, distinctUntilChanged } from 'rxjs/operators';
import { RaceService } from 'src/app/service/http/race/race.service';
import { IRace } from 'src/app/models/race.interface';
import { of, interval } from 'rxjs';
import {PageAddFirstStreaming, PageFullSreen, PageLoadingHide} from '../actions/page.actions';
import {environment} from '../../../environments/environment';

@Injectable()
export class RaceEffects {
  
  getRace$ = createEffect(() => this._action$.pipe(
    ofType<GetRace>(ERaceActions.GetRace),
    switchMap((action) => interval(10000).pipe(startWith(0), mapTo(action))),
    switchMap((action) => this._raceService.getRace(action.payload)),
    distinctUntilChanged((prev, curr) => {
      if (JSON.stringify(prev) === JSON.stringify(curr)) {
        this._store.dispatch(new PageLoadingHide());
        return true;
      }
    }),
    switchMap((race: IRace) => {
        if (race && race.video &&
            (race.video.srcid && environment.replayIdPartner.includes(String(race.video.srcid))) &&
            race.video.srcid && race.video.url !== '') {
            console.log('GetRaceVideoXBNET');
            return of(new GetRaceVideoXBNET(race));
        }
        return of(new GetRaceSuccess(race), new PageLoadingHide());
    })
  ));

  GetRaceVideoXBNET$ = createEffect(() => this._action$.pipe(
    ofType<GetRaceVideoXBNET>(ERaceActions.GetRaceVideoXBNET),
    switchMap((action) => this._raceService.getVideoRepley(action.payload)),
    switchMap((race: IRace) => {
        return of(new GetRaceSuccess(race), new PageLoadingHide());
    })
  ));

  constructor(private _raceService: RaceService, private _action$: Actions, private _store: Store<IAppState>) {}
}
